import { render, staticRenderFns } from "./projectManage.vue?vue&type=template&id=4fbaad7e&scoped=true&"
import script from "./projectManage.vue?vue&type=script&lang=js&"
export * from "./projectManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbaad7e",
  null
  
)

export default component.exports